import { getServerUrl } from "utils/fetch";

export function getTrends(query) {
  return {
    url: getServerUrl("/trends"),
    method: "GET",
  };
}
